// extracted by mini-css-extract-plugin
export default {"user__orderProducts":"UserOrderProductsShort_user__orderProducts__lgk0a","user__orderImage":"UserOrderProductsShort_user__orderImage__8-l6N"};